/* Shreeva: cart progress bar (free delivery -> free gift) + free gift pouch the shopper can choose (jaggery or ragi). */
(function () {
  var de = document.documentElement;
  var FREE = parseInt(de.getAttribute('data-sn-free') || '0', 10);
  var GIFT = parseInt(de.getAttribute('data-sn-gift') || '0', 10);
  var GVS = (de.getAttribute('data-sn-gift-variant') || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
  var GLB = (de.getAttribute('data-sn-gift-labels') || 'Jaggery,Ragi').split(',');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, syncing = false, failed = false;
  function fmt(p) { return '₹' + Math.ceil(p / 100).toLocaleString('en-IN'); }
  function isGift(it) { return it.properties && it.properties._gift; }
  function base(c) { var t = 0; c.items.forEach(function (it) { if (!isGift(it)) t += it.final_line_price; }); return t; }
  function pref() { try { var p = parseInt(sessionStorage.getItem('sn-gift'), 10); if (GVS.indexOf(p) > -1) return p; } catch (e) {} return GVS[0]; }
  function setPref(id) { try { sessionStorage.setItem('sn-gift', String(id)); } catch (e) {} }
  function html(t, giftId) {
    var msg, pct, ok = false, pick = '';
    if (t < FREE) {
      pct = t * 100 / FREE;
      msg = 'Add <strong>' + fmt(FREE - t) + '</strong> more for <strong>FREE delivery</strong> 🚚';
    } else if (GIFT && t < GIFT) {
      pct = t * 100 / GIFT;
      msg = '✓ FREE delivery on every order · Add <strong>' + fmt(GIFT - t) + '</strong> more for a <strong>FREE 500 g jaggery or ragi pouch</strong> 🎁';
    } else {
      pct = 100; ok = true;
      msg = GIFT ? '🎉 <strong>FREE delivery</strong> + <strong>FREE 500 g pouch</strong> unlocked' : '🎉 You’ve unlocked <strong>FREE delivery</strong>';
      if (GIFT && GVS.length > 1) {
        var cur = giftId || pref();
        pick = '<span class="sn-fbar__pick" role="group" aria-label="Choose your free pouch"><span>Choose your free pouch:</span>' +
          GVS.map(function (id, i) { return '<button type="button" class="sn-gift-pick" data-sn-gift-pick="' + id + '" aria-pressed="' + (id === cur) + '">' + (GLB[i] || 'Option ' + (i + 1)) + '</button>'; }).join('') + '</span>';
      }
    }
    pct = Math.max(0, Math.min(100, Math.round(pct)));
    return '<div class="sn-fbar' + (ok ? ' sn-fbar--ok' : '') + '" role="status">' + msg + pick +
      '<span class="sn-fbar__track" aria-hidden="true"><span style="width:' + pct + '%"></span></span></div>';
  }
  function place(t, count, giftId) {
    document.querySelectorAll('#CartDrawer .drawer__footer, .cart__footer .cart__blocks').forEach(function (el) {
      var old = el.querySelector(':scope > .sn-fbar');
      if (!count) { if (old) old.remove(); return; }
      var w = document.createElement('div'); w.innerHTML = html(t, giftId);
      if (old) old.replaceWith(w.firstChild); else el.insertBefore(w.firstChild, el.firstChild);
    });
  }
  function rerender() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    return fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var p = new DOMParser();
      var cur = document.getElementById('CartDrawer');
      if (cur && s['cart-drawer']) {
        var n = p.parseFromString(s['cart-drawer'], 'text/html').getElementById('CartDrawer');
        if (n) {
          cur.innerHTML = n.innerHTML;
          var cd = document.querySelector('cart-drawer'), ov = document.getElementById('CartDrawer-Overlay');
          if (cd && ov && cd.close) ov.addEventListener('click', cd.close.bind(cd));
          var inner = cur.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          if (cd) cd.classList.remove('is-empty');
        }
      }
      var b = document.getElementById('cart-icon-bubble');
      if (b && s['cart-icon-bubble']) {
        var m = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (m) b.innerHTML = m.innerHTML;
      }
    }).catch(function () {});
  }
  function post(url, body) {
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function addGift(id) { return post('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _gift: 'Free 500 g pouch' } }] }); }
  function done() { syncing = false; setTimeout(refresh, 400); }
  function syncGift(c, t) {
    if (!GIFT || !GVS.length || syncing) return false;
    var giftLines = c.items.filter(isGift), want = pref();
    if (t >= GIFT && !giftLines.length && !failed) {
      syncing = true;
      addGift(want).then(rerender).catch(function () { failed = true; }).then(done);
      return true;
    }
    if (t >= GIFT && giftLines.length && giftLines[0].variant_id !== want && !failed) {
      syncing = true;
      var u = {}; giftLines.forEach(function (l) { u[l.key] = 0; });
      post('cart/update.js', { updates: u }).then(function () { return addGift(want); }).then(rerender).catch(function () { failed = true; }).then(done);
      return true;
    }
    if (t < GIFT && giftLines.length) {
      syncing = true;
      var updates = {}; giftLines.forEach(function (l) { updates[l.key] = 0; });
      post('cart/update.js', { updates: updates }).then(rerender).catch(function () {}).then(done);
      return true;
    }
    return false;
  }
  function refresh() {
    if (busy || syncing) return;
    busy = true;
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var t = base(c), g = c.items.filter(isGift)[0];
        place(t, c.item_count, g ? g.variant_id : 0);
        syncGift(c, t);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  var timer;
  function onChange() { clearTimeout(timer); timer = setTimeout(refresh, 300); }
  function init() {
    refresh();
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button.sn-gift-pick[data-sn-gift-pick]') : null;
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var id = parseInt(b.getAttribute('data-sn-gift-pick'), 10);
      if (id === pref() && b.getAttribute('aria-pressed') === 'true') return;
      setPref(id); failed = false;
      b.parentNode.querySelectorAll('button.sn-gift-pick').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      refresh();
    });
    var root = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var ours = false;
        list[i].addedNodes.forEach(function (a) { if (a.classList && a.classList.contains('sn-fbar')) ours = true; });
        list[i].removedNodes.forEach(function (a) { if (a.classList && a.classList.contains('sn-fbar')) ours = true; });
        if (!ours) { onChange(); return; }
      }
    }).observe(root, { childList: true, subtree: true });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, onChange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
